var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
/**
 * Kareo wrapped component of the Material-UI AccordionDetails. The prop API has been limited to props defined in AccordionDetailsProps.
 *
 * Material-UI AccordionDetails: [Docs](https://v4.mui.com/components/accordion/), [API](https://v4.mui.com/api/accordion-details/)
 *
 * @storybook: [Accordion](http://design.kareoprod.ent/design-system/?path=/story/components-surfaces-accordion--simple-and-disabled-accordion)
 */
var AccordionDetails = React.forwardRef(function (props, ref) { return (React.createElement(MuiAccordionDetails, __assign({}, props, { ref: ref }))); });
AccordionDetails.displayName = 'KareoAccordionDetails';
export default AccordionDetails;
